import { getLocale, localizeMoney } from '@raisin/cp-utils';
import messages from './messages';
export const getAccount = (transactionAccount, t, isCustomerActive, locale = '') => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { iban = undefined, accountNumber = undefined, sortCode = undefined } = transactionAccount;
    if (!isCustomerActive)
        return [];
    return locale.toLowerCase() === getLocale('en-GB').cmsFormat
        ? [
            {
                label: t(messages.accountNo),
                id: accountNumber,
                size: 'small',
            },
            {
                label: t(messages.sortCode),
                id: sortCode,
                size: 'small',
            },
        ]
        : [
            {
                id: iban,
            },
        ];
};
export const getTotalBalance = (customer, transactionAccount, intl, t) => {
    const { isPendingActivation } = customer !== null && customer !== void 0 ? customer : {};
    const { currencyCode = 'EUR', balance = { current: 0 } } = transactionAccount !== null && transactionAccount !== void 0 ? transactionAccount : {};
    const label = t(messages.balance);
    if (isPendingActivation) {
        return {
            label,
            amount: localizeMoney({ currency: currencyCode, value: 0 }, intl.locale),
        };
    }
    return {
        label,
        amount: localizeMoney({ currency: currencyCode, value: balance === null || balance === void 0 ? void 0 : balance.current }, intl.locale),
        isNegative: (balance === null || balance === void 0 ? void 0 : balance.current) < 0,
    };
};
export const getAvailableBalance = (customer, transactionAccount, intl, t) => {
    const { isPendingActivation } = customer !== null && customer !== void 0 ? customer : {};
    const { currencyCode = 'EUR', balance = { current: 0, available: 0 } } = transactionAccount !== null && transactionAccount !== void 0 ? transactionAccount : {};
    /* eslint-enable @typescript-eslint/naming-convention */
    const label = t(messages.availableAmount);
    if (isPendingActivation) {
        return {
            label,
            amount: localizeMoney({ currency: currencyCode, value: balance === null || balance === void 0 ? void 0 : balance.current }, intl.locale),
        };
    }
    return {
        label,
        amount: localizeMoney({ currency: currencyCode, value: balance === null || balance === void 0 ? void 0 : balance.available }, intl.locale),
    };
};
//# sourceMappingURL=account.js.map